import React from "react";
import { inject, observer } from "mobx-react";
import { ValidatedValue } from "../../../helpers/validator";
import { CalculateStore } from "../../../stores/calculateStore";
import TextInput from "../textInput/textInput";
import Notification from "../notification/notification";

interface NipProps {
    calculateStore?: CalculateStore;
    value: ValidatedValue<string> | undefined;
    disabled?: boolean;
    required?: boolean;
    recalculate?: boolean;
}

export function Nip(props: NipProps) {
    const calculateStore = props.calculateStore!;
    const recalculateOnChange = props.recalculate ?? false;
    return (
        <div className="nip">
            <div className="question-answer-container">
                <div className="question">NIP</div>
                {renderNip()}
            </div>
        </div>
    );

    function renderNip() {
        const nipLength: number = 10;

        return (
            <div className="nip-container">
                <TextInput
                    disabled={props.disabled}
                    validatedValue={props.value}
                    onChange={(value) => {
                        props.value!.setValue(value);
                        if (recalculateOnChange) {
                            calculateStore.setRequireRecalculate(true);
                            calculateStore.setRequireRecalculatePackages();
                        }
                    }}
                    onlyNumberValue={true}
                    topLabel="NIP"
                    maxLength={nipLength}
                    getHelperText={() => getHelperText()}
                />
            </div>);
    }

    function getHelperText() {
        if (!!props.value?.errorMessage) {
            return (<Notification type="error" message={props.value?.errorMessage} />);
        } else {
            return (!props.required) ? <Notification type="info" message="Opcjonalne" /> : "";
        }
    }
}

export default inject("calculateStore")(observer(Nip));
